import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getScenarioTaskIds} from 'helpers/game-helper';
import {shuffleArray} from 'helpers/array-helper';
import LandingPage from 'components/landing-page/landing-page';
import Game from 'components/game/game';
import Result from 'components/result/result';

class GameController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			shuffleTasks: true,
			ignoreTimer: false,
			gameStatus: 'ready', // ready, open, done
			startTime: null,
			endTime: null,
			durationMinutes: 3,
			playerData: {},
			taskIds: []
		};
		this.timeout = null;
	}

	/**
	 * Component mounted
	 */
	componentDidMount = () => {
		const taskIds = (this.state.shuffleTasks 
			? shuffleArray(getScenarioTaskIds(this.props.scenarioId)) 
			: getScenarioTaskIds(this.props.scenarioId));
		this.setState({taskIds});
	};

	/**
	 * Component will unmount
	 */
	componentWillUnmount = () => {
		/* Clear timeout */
		if (this.timeout) clearTimeout(this.timeout);
	};

	/**
	 * Start game
	 */
	handleStartGame = () => {
		this.setState({
			startTime: Date.now(), 
			gameStatus: 'open'
		}, () => {
			const durationMiliSeconds = this.state.durationMinutes * 60 * 1000;
			this.timeout = setTimeout(() => {
				this.handleFinishGame('auto');
			}, durationMiliSeconds);
		});
	};

	/**
	 * Finish game
	 */
	handleFinishGame = (type) => {
		if (type === 'manual') {
			this.setState({
				gameStatus: 'done',
				endTime: Date.now()
			});
		}
		if (this.state.gameStatus === 'open' && !this.state.ignoreTimer) {
			this.setState({
				gameStatus: 'done',
				endTime: Date.now()
			});
		}
		if (this.timeout) clearTimeout(this.timeout);
	};

	/**
	 * Update player data
	 * @param {object} updates
	 * @returns {promise}
	 */
	updatePlayerData = (updates) => {
		if (Object.keys(updates).length === 0 && updates.constructor === Object) {
			return new Promise((resolve)=>{resolve({status: 'success'});});
		}

		const newPlayerData = Object.assign({}, this.state.playerData, {...updates});
		this.setState({playerData: newPlayerData}, () => {
			return new Promise((resolve)=>{resolve({status: 'success'});});
		});
	};

	/**
	 * Reset game progress
	 * @returns {promise}
	 */
	resetGameProgress = () => {
		const taskIds = (this.state.shuffleTasks 
			? shuffleArray(getScenarioTaskIds(this.props.scenarioId)) 
			: getScenarioTaskIds(this.props.scenarioId));
		this.setState({taskIds});
		this.setState({
			playerData: {},
			startTime: null,
			endTime: null,
			gameStatus: 'ready',
			taskIds
		});
	};

	toggleShuffleTasks = () => {
		this.setState({shuffleTasks: !this.state.shuffleTasks});
	};
	toggleIgnoreTimer = () => {
		this.setState({ignoreTimer: !this.state.ignoreTimer});
	};

	/**
	 * Render component
	 */
	render = () => {

		/* Game results */
		if (this.state.gameStatus === 'done') {
			return (
				<Result 
					scenarioId={this.props.scenarioId}
					startTime={this.state.startTime}
					endTime={this.state.endTime}
					playerData={this.state.playerData}
					updateBackground={this.props.updateBackground}
					resetGameProgress={this.resetGameProgress}
				/>
			);
		}
		/* Game */
		if (this.state.gameStatus === 'open') {
			return (
				<Game 
					startTime={this.state.startTime}
					durationMinutes={this.state.durationMinutes}
					scenarioId={this.props.scenarioId}
					playerData={this.state.playerData}
					taskIds={this.state.taskIds}
					handleFinishGame={this.handleFinishGame}
					updatePlayerData={this.updatePlayerData}
					updateBackground={this.props.updateBackground}
				/>
			);
		}

		/* Landing page */
		return (
			<LandingPage 
				shuffleTasks={this.state.shuffleTasks}
				ignoreTimer={this.state.ignoreTimer}
				scenarioId={this.props.scenarioId}
				updateBackground={this.props.updateBackground}
				handleStartGame={this.handleStartGame}
				resetGameProgress={this.resetGameProgress}
				toggleShuffleTasks={this.toggleShuffleTasks}
				toggleIgnoreTimer={this.toggleIgnoreTimer}
			/>
		);
	};
}

GameController.propTypes = {
	scenarioId: PropTypes.string.isRequired,
	updateBackground: PropTypes.func.isRequired,
};

export default GameController;
